import { Button, Grid, MenuItem, Typography } from '@material-ui/core'

// TODO: note, we need to figure out how to manage the MUI v5+ package. Curently this '@mui/material` package is not
// directly available, yet is accessible from our code. Not sure how this works, but we should talk about it and 
// standardize it so it doesn't confused developers (like Aaron).
import TextField from '@mui/material/TextField'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import PublicWrapper from '../../components/public-wrapper-v2/public-wrapper'
import { setUserAction } from '../../stores/user/user-action'
import { allowOnlyLettersDashesAndApostrophes, checkIfNumsDontMatch, formatToPhoneNumber, formIsNotValid, getPhoneNumberHelperText, removeNonNumbers } from './adf-screener-info-manager'
import useAdfScreenerPageStyles from './adf-screener-personal-info-page.styles'

export default function AdfScreenerPersonalInfoPage() {
    const user = useSelector((state: any) => state.user)
    const dispatch = useDispatch()
    const styleClasses = useAdfScreenerPageStyles()
    const navigate = useNavigate()
    const [firstName, setFirstName] = useState(user.firstName ?? '') 
    const [lastName, setLastName] = useState(user.lastName ?? '')
    const [countryCode, setCountryCode] = useState('1')
    const [mobileNumber, setMobileNumber] = useState('')
    const [confirmMobileNumber, setConfirmMobileNumber] = useState('')
    const [numbersDontMatch, setNumbersDontMatch] = useState(false)
    const { search } = useLocation()
    const preRegistrationId =  new URLSearchParams(search).get('id')


    useEffect(() => {
        if (!preRegistrationId) {
            navigate('/connect')
            return;
        }
    }, [])

    useEffect(() => {
        const matchStatus = checkIfNumsDontMatch(mobileNumber, confirmMobileNumber)
        setNumbersDontMatch(matchStatus)
    }, [mobileNumber, confirmMobileNumber])
    
    function onConfirm() {
        navigate('/connect/in-usa')
        
        const userAction = setUserAction({
            ...user,
            firstName,
            lastName,
            countryCode,
            mobileNumber: removeNonNumbers(mobileNumber),
            preRegistrationId
        })
        
        dispatch(userAction)
    }
    
    
    return (
        <div className={styleClasses.trapezoidBgContactInfo}>
            <PublicWrapper
                data-testid='publicWrapper'
                title=''
                displayPrivacyPolicyFooter={true}
                backgroundClass={styleClasses.root}
                contentWrapperClass={styleClasses.contactInfoWrapper}
            >
                <div className={styleClasses.mainBox}>
                    <div className={styleClasses.title}>
                        <Typography variant='h6' className={`${styleClasses.subtitle}`}>
                            Welcome! Let's start with your information
                        </Typography>
                    </div>
                    <div className={styleClasses.contentClass}>
                        <Grid container justifyContent='flex-end' spacing={2}>

                            {/* Name Field */}
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='first-name'
                                    variant='outlined'
                                    label='First Name'
                                    fullWidth
                                    size='small'
                                    value={firstName}
                                    onChange={(e) => setFirstName(allowOnlyLettersDashesAndApostrophes(e.target.value))}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='last-name'
                                    variant='outlined'
                                    label='Last Name'
                                    fullWidth
                                    size='small'
                                    value={lastName}
                                    onChange={(e) => setLastName(allowOnlyLettersDashesAndApostrophes(e.target.value))}
                                />
                            </Grid>

                            {/* Mobile Number Field */}
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='phone-country-code'
                                    select
                                    label='Phone Country Code'
                                    variant='outlined'
                                    fullWidth
                                    size='small'
                                    disabled={true}
                                    className={styleClasses.countryCode}
                                    value={countryCode}
                                >
                                    <MenuItem value={1}>United States (+1)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='mobile-number'
                                    variant='outlined'
                                    label='Mobile Number'
                                    fullWidth
                                    size='small'
                                    value={mobileNumber}
                                    onChange={(e) => formatToPhoneNumber(e.target.value, setMobileNumber)}
                                    error={numbersDontMatch}
                                />
                            </Grid>

                            {/* Confirm Mobile Number */}
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='confirm-country-code'
                                    select
                                    label='Confirm Country Code'
                                    variant='outlined'
                                    fullWidth
                                    size='small'
                                    disabled={true}
                                    className={styleClasses.countryCode}
                                    value={countryCode}
                                >
                                    <MenuItem value={1}>United States (+1)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    id='confirm-mobile-number'
                                    variant='outlined'
                                    label='Confirm Mobile Number'
                                    fullWidth
                                    size='small'
                                    value={confirmMobileNumber}
                                    onChange={(e) => formatToPhoneNumber(e.target.value, setConfirmMobileNumber)}
                                    error={numbersDontMatch}
                                    helperText={getPhoneNumberHelperText(numbersDontMatch)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <div className={styleClasses.contentInfo}>
                                    <p>
                                        Should you need to return to your application at a later time, you’ll be asked to authenticate using both your email and phone.
                                    </p>
                                </div>
                            </Grid>

                            {/* Continue button */}
                            <Grid item xs={12} md={6} className={styleClasses.continueButton}>
                                <Button
                                    id='continue-button'
                                    color='primary'
                                    disabled={formIsNotValid(firstName, lastName, countryCode, mobileNumber, confirmMobileNumber)}
                                    variant='contained'
                                    onClick={onConfirm}
                                    data-testid='continueButton'
                                    className={styleClasses.button}
                                >
                                    <span style={{ padding: '0 3rem' }}>Continue</span>
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </PublicWrapper>
        </div>
    );
}